import addEmployeeDialog from '@/components/modules/org/structure/staff/dialogs/addEmployeeDialog'
import moveEmployeeDialog from '@/components/modules/org/structure/staff/dialogs/moveEmploeeDialog'
import addDivisionDialog from '@/components/modules/org/structure/divisions/dialogs/addDivisionDialog'
import poUserDialog from '@/components/modules/org/structure/staff/dialogs/setPOUserDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import { UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import { ORG_SET_DIVISION, ORG_SET_USER, ORG_LOCK_EMPLOEE, ORG_DEL_DIVISION } from '@/store/actions/org'

export const cptyStructureMgmtMixin = {
  components: {
    addEmployeeDialog,
    moveEmployeeDialog,
    addDivisionDialog,
    poUserDialog,
    SysConfirmDialog
  },
  data () {
    return {
      showAddEmployeeDialog: false,
      showMoveEmployeeDialog: false,
      showAddDivisionDialog: false,
      showPOUserDialog: false,
      showConfirmDialog: false,
      currentDelMessage: '',
      currentConfirmAction: function () {},
      addDivisionMode: 'create',
      addEmployeeMode: 'create',
      addEmployeeUser: null,
      moveEmployeeUser: null,
      // actions
      addDivision: { text: 'Добавить подразделение', actionType: 'Структура', action: 'addDivision', method: this.doAddDivision, icon: 'mdi-plus', params: '' },
      updDivision: { text: 'Редактировать подразделение', actionType: 'Структура', action: 'updDivision', method: this.doUpdDivision, icon: 'mdi-book-edit-outline', params: '' },
      delDivision: { text: 'Удалить подразделение', actionType: 'Структура', action: 'delDivision', method: this.confirmDelDivision, icon: 'mdi-delete', params: '' },
      addEmployee: { text: 'Добавить сотрудника', actionType: 'Структура', action: 'addEmployee', method: this.doAddEmployee, icon: 'mdi-account-plus-outline', params: '' },
      updEmployee: { text: 'Редактировать сотрудника', actionType: 'Сотрудники', action: 'updEmployee', method: this.doUpdEmployee, icon: 'mdi-account-edit-outline', params: '' },
      moveEmployee: { text: 'Переместить сотрудника', actionType: 'Сотрудники', action: 'moveEmployee', method: this.doMoveEmployee, icon: 'mdi-account-arrow-right-outline', params: '' },
      delEmployee: { text: 'Удалить сотрудника', actionType: 'Сотрудники', action: 'delEmployee', method: this.confirmDelEmployee, icon: 'mdi-account-remove-outline', params: '' },
      makeUser: { text: 'Сделать пользователем ЛК', actionType: 'Сотрудник', action: 'makeUser', method: this.doMakeUser, icon: 'mdi-account-check-outline', params: '' },
      updUserWO: { text: 'Рабочие области пользователя', actionType: 'Сотрудник', action: 'updUserWO', method: this.doUpdUserWO, icon: 'mdi-account-eye-outline', params: '' },
      lockUser: { text: 'Блокировать пользователя', actionType: 'Сотрудник', action: 'lockUser', method: this.doLockUser, icon: 'mdi-account-off-outline', params: '' }
    }
  },
  computed: {
    currentUser: {
      get: function () {
        return this.$store.getters.getCurrentUser
      }
    },
    currentDivision: {
      get: function () {
        return this.$store.getters.getCurrentDiv
      }
    }
  },
  watch: {
    selectedNode (val) {
      this.setStructureActions()
      this.setEmpActions()
      this.setUsrActions()
    }
  },
  mounted: function () {
    this.$store.commit(ORG_SET_USER, {})
    this.$store.commit(ORG_SET_DIVISION, {})
  },
  methods: {
    doCloseConfirmDialog () {
      this.showConfirmDialog = false
    },
    doConfirmedAction () {
      this.doCloseConfirmDialog()
      this.currentConfirmAction()
    },
    doAddEmployee (param) {
      this.addEmployeeUser = null
      this.addEmployeeMode = 'create'
      this.showAddEmployeeDialog = true
    },
    doUpdEmployee (param) {
      this.addEmployeeUser = this.currentUser
      this.addEmployeeMode = 'edit'
      this.showAddEmployeeDialog = true
    },
    doMoveEmployee (param) {
      this.moveEmployeeUser = this.currentUser
      this.showMoveEmployeeDialog = true
    },
    confirmDelEmployee () {
      this.currentDelMessage = 'Удаление учётной записи сотрудника'
      this.currentConfirmAction = this.doDelEmployee
      this.showConfirmDialog = true
    },
    doDelEmployee (param) {
      this.showConfirmDialog = false
      const payload = {
        INST_UUID: this.currentUser.INST_UUID,
        EMP_ID: this.currentUser.EMP_ID,
        SIGNAL: -1,
        ITP_ID: this.currentUser.ITP_ID
      }
      this.$store.dispatch(ORG_LOCK_EMPLOEE, payload)
        .then((resp) => {
          console.log('User deletion returned ', resp)
          this.$store.commit(ORG_SET_USER, {})
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка удаления сотрудника: ' + err })
          console.log('Ошибка удаления сотрудника', err)
        })
    },
    doMakeUser (param) {
      this.showPOUserDialog = true
    },
    doLockUser (param) {
      this.showPOUserDialog = true
    },
    doUpdUserWO (param) {
      alert('Не реализовано')
    },
    confirmDelDivision () {
      this.currentDelMessage = 'Удаление подразделения'
      this.currentConfirmAction = this.doDelDivision
      this.showConfirmDialog = true
    },
    doDelDivision (param) {
      this.showConfirmDialog = false
      this.$store.dispatch(ORG_DEL_DIVISION, { INST_UUID: this.currentDivision.INST_UUID, ITP_ID: this.currentDivision.ITP_ID, PITP_ID: this.currentDivision.PITP })
        .then((resp) => {
          this.$refs.orgTree.setActiveNode(resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка удаления подразделения: ' + err })
          console.log('Ошибка удаления подразделения', err)
        })
    },
    doEmployeeAdded (data) {
      this.showAddEmployeeDialog = false
      this.$refs.orgTree.setActive(data)
    },
    doEmployeeChanged (data) {
      this.showAddEmployeeDialog = false
      this.showPOUserDialog = false
      console.log('showPOUserDialog is ', this.showPOUserDialog)
      this.$refs.orgTree.setActive(data)
    },
    doEmployeeMoved (data) {
      this.showMoveEmployeeDialog = false
      this.moveEmployeeUser = null
      console.log('Moved user is ', data)
      this.$refs.orgTree.setActive(data)
    },
    doAddDivision (param) {
      this.addDivisionMode = 'create'
      this.showAddDivisionDialog = true
    },
    doUpdDivision () {
      this.addDivisionMode = 'edit'
      this.showAddDivisionDialog = true
    },
    doDivisionAdded (data) {
      this.showAddDivisionDialog = false
      this.$refs.orgTree.addChild(data)
    },
    doDivisionChanged (data) {
      this.showAddDivisionDialog = false
    },
    resetActions (actionType) {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: actionType, actions: [] })
    },
    async setStructureActions () {
      await this.resetActions('Структура')
      if (!this.currentDivision) { return }
      const actionPayload = {
        actionType: 'Структура',
        actions: []
      }
      if (this.currentDivision.isTech === '0') {
        actionPayload.actions.push(this.addDivision)
        actionPayload.actions.push(this.updDivision)
        actionPayload.actions.push(this.delDivision)
        actionPayload.actions.push(this.addEmployee)
      }
      if (this.currentDivision.isTech === '-1') {
        actionPayload.actions.push(this.addDivision)
      }
      this.$store.dispatch(UI_SET_ACTIONS, actionPayload)
    },
    async setEmpActions () {
      await this.resetActions('Сотрудники')
      if (!this.currentUser) { return }
      const actionPayload = {
        actionType: 'Сотрудники',
        actions: []
      }
      if (this.currentDivision && this.currentDivision.isTech !== '1') {
        actionPayload.actions.push(this.updEmployee)
        actionPayload.actions.push(this.delEmployee)
      }
      actionPayload.actions.push(this.moveEmployee)
      this.$store.dispatch(UI_SET_ACTIONS, actionPayload)
    },
    async setUsrActions () {
      await this.resetActions('Сотрудник')
      if (!this.currentUser) { return }
      const actionPayload = {
        actionType: 'Сотрудник',
        actions: []
      }
      if (Number(this.currentUser.USR_ID) <= 0 && this.currentDivision.isTech !== '1') {
        actionPayload.actions.push(this.makeUser)
      }
      if (Number(this.currentUser.IS_ACTIVE_USR) === 0 && this.currentDivision.isTech !== '1') {
        this.lockUser.text = 'Блокировать пользователя'
        actionPayload.actions.push(this.lockUser)
      }
      if (Number(this.currentUser.IS_ACTIVE_USR) === -1 && this.currentDivision.isTech !== '1') {
        this.lockUser.text = 'Активировать пользователя'
        actionPayload.actions.push(this.lockUser)
        actionPayload.actions.push(this.updUserWO)
      }
      this.$store.dispatch(UI_SET_ACTIONS, actionPayload)
    }
  }
}
